import { Router } from "@frui.ts/screens/dist";
import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { isModuleViewModel } from "../../utils/isModuleViewModel";
import type { IModuleViewModel } from "../../viewModels/types";

const SideMenu: ViewComponent<IModuleViewModel> = observer(({ vm }) => {
  const getUrl = Router.getChildUrlFactory(vm);

  return (
    <ListGroup variant="flush">
      {vm.children.map((item, i) => (
        <React.Fragment key={i}>
          <ListGroupItem
            action
            as="a"
            href={getUrl(item)}
            variant="secondary"
            className={
              isModuleViewModel(item) && item.hasOwnProperty("showChildrenSubmenu") && item.showChildrenSubmenu
                ? "has-submenu"
                : ""
            }
            active={vm.activeChild === item}
            onClick={(e: any) => {
              e.preventDefault();
              vm.tryActivateChild(item);
            }}>
            {item.name}
          </ListGroupItem>
          {isModuleViewModel(item) &&
            item.hasOwnProperty("showChildrenSubmenu") &&
            item.showChildrenSubmenu &&
            vm.activeChild === item &&
            (item as IModuleViewModel).children.map((subItem, j) => (
              <ListGroupItem
                as="a"
                className="list-group-subitem"
                key={`sub-${j}`}
                href={getUrl(subItem)}
                variant="secondary"
                active={item.activeChild === subItem}
                onClick={(e: any) => {
                  e.preventDefault();
                  item.tryActivateChild(subItem);
                }}>
                <span className="pl-2">{subItem.name}</span>
              </ListGroupItem>
            ))}
        </React.Fragment>
      ))}
    </ListGroup>
  );
});

export default SideMenu;
